module.exports = __webpack_public_path__ + "img/N11.a03dd69d.png";